






import { Component, Prop } from "vue-property-decorator";
import { DropdownBase } from "../drop-down/dropdown-base";

@Component({})

export default class TZDropdown extends DropdownBase {
    @Prop() selectedOffset: string;

    opened = true;

    mounted() {
        this.$nextTick(() => {
            //scroll to active item
            const index = this.list.findIndex((value) => value.id === this.selectedOffset)
            if(index >= 0) {
                const target = Array.from(this.$el.children)[index] as HTMLElement;
                if(target && target.parentElement) {
                    target.parentElement.scrollTop = target.offsetTop
                }
            }
        })
    }
}

